import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";

const markAllReadInPayload = (queryKey, apiResponse) => {
	if (!apiResponse?.data || !Array.isArray(apiResponse.data.records)) {
		return apiResponse;
	}

	const queryParams = Array.isArray(queryKey) ? queryKey[1] || {} : {};
	const isUnreadList = queryParams.status === "unread";
	const isRecentUnreadList = queryParams.recent === true;

	const allCount = Number(apiResponse.data.all_count ?? apiResponse.data.total_records ?? 0);

	return {
		...apiResponse,
		data: {
			...apiResponse.data,
			records: isUnreadList || isRecentUnreadList
				? []
				: apiResponse.data.records.map((record) => ({
					...record,
					was_read: true,
				})),
			unread_count: 0,
			read_count: allCount,
		},
	};
};

const useMarkAllNotificationsAsRead = () => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();

	const markAllAsRead = async (payload = {}) => {
		const instance = await InitApi({ accessToken });
		const res = await instance.patch("notifications/read-all", payload);
		return res.data;
	};

	return useMutation(markAllAsRead, {
		onMutate: async () => {
			await queryClient.cancelQueries(["notifications"]);

			const previousQueries = queryClient.getQueriesData(["notifications"]);

			previousQueries.forEach(([queryKey, queryData]) => {
				queryClient.setQueryData(queryKey, markAllReadInPayload(queryKey, queryData));
			});

			return { previousQueries };
		},
		onError: async (error, _payload, context) => {
			if (context?.previousQueries) {
				context.previousQueries.forEach(([queryKey, queryData]) => {
					queryClient.setQueryData(queryKey, queryData);
				});
			}

			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
		onSettled: async () => {
			await queryClient.invalidateQueries(["notifications"]);
		},
	});
};

export default useMarkAllNotificationsAsRead;
